module.exports = __webpack_public_path__ + "static/media/ball_ended_hook_pig_tail_hook.b07aa675.webp";